import BU8000 from "../assets/BU8000.png";
import Q60B from "../assets/Q60B.png";
// import Q65B from "../assets/Q65B.png";
import Q70A from "../assets/Q70A.png";
import Q80B from "../assets/Q80B.png";
import QN85B from "../assets/QN85B.png";
import QN90B from "../assets/QN90B.png";
import QN800B from "../assets/QN800B.png";
import QN900B from "../assets/QN900B.png";
import TheFrame from "../assets/the-frame.png";
import TheFreestyle from "../assets/the-freestyle.png";
// import ThePremiere from "../assets/the-premiere.png";
import TheSerif from "../assets/the-serif.png";
import TheSero from "../assets/the-sero.png";

const products =  {
  "QN75QN900BGXZD": {
      "sku": "QN75QN900BGXZD",
      "size": "75",
      "displayName": "QN900",
      "cardColor": "#212D9B",
      "family": "Neo QLED 8K",
      "description": "Samsung Smart TV 75\" Neo QLED 8K QN900B 2022, Mini Led, Painel 120hz, Processador com IA, Som em Movimento, Tela Infinita, Ultrafina, Única Conexão, Alexa built in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn900b-75-inch-neo-qled-8k-smart-tv-qn75qn900bgxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN900BGXZDPDP-SSG-LANDINGPAGE-NA-NALP849852SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN900BGXZDPDP-SSG-LANDINGPAGE-NA-NALP849852SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com.br/samsung-smart-tv-2045/p?skuId=2913",
      "shopUrlTagged": "https://shop.samsung.com.br/samsung-smart-tv-2045/p?skuId=2913&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN900BGXZD-SSG-LANDINGPAGE-NA-NALP286208SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN900BGXZD-SSG-LANDINGPAGE-NA-NALP286208SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2913&qty=1&seller=samsung&sc=1&sku=2917&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2913&2917-SSG-LANDINGPAGE-NA-NALP1718574SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2913&2917-SSG-LANDINGPAGE-NA-NALP1718413SRC-NA&keeplink=true",
      "price": "52299",
      "priceFormatted": "R$52.299,00",
      "image": {
        "src": QN900B,
        "thumbnail": QN900B,
        "alt": "QN900B de 75 polegadas"
      },
      "passions": [
        "sports",
        "movies",
        "smart",
      ],
      "features": [
          "8K",
          "smart8K",
      ],
      "specs": {
          "thickness": "1.5cm",
          "border": "Sem Borda",
          "singleConnection": "Sim",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "8K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Altíssimo",
          "brightness": "Altíssimo",
          "processor": "Quantum 8K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "PRO",
          "soundPower": "90W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN85QN900BGXZD": {
      "sku": "QN85QN900BGXZD",
      "size": "85",
      "displayName": "QN900",
      "cardColor": "#212D9B",
      "family": "Neo QLED 8K",
      "description": "Samsung Smart TV 85\" Neo QLED 8K QN900B 2022, Mini Led, Painel 120hz, Processador com IA, Som em Movimento, Tela Infinita, Ultrafina, Única Conexão, Alexa built in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn900b-85-inch-neo-qled-8k-smart-tv-qn85qn900bgxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN900BGXZDPDP-SSG-LANDINGPAGE-NA-NALP849853SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN900BGXZDPDP-SSG-LANDINGPAGE-NA-NALP849853SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com.br/samsung-smart-tv-2045/p?skuId=2914",
      "shopUrlTagged": "https://shop.samsung.com.br/samsung-smart-tv-2045/p?skuId=2914&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN900BGXZD-SSG-LANDINGPAGE-NA-NALP286209SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN900BGXZD-SSG-LANDINGPAGE-NA-NALP286209SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2914&qty=1&seller=samsung&sc=1&sku=2917&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2914&2917-SSG-LANDINGPAGE-NA-NALP1718575SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2914&2917-SSG-LANDINGPAGE-NA-NALP1718414SRC-NA&keeplink=true",
      "price": "79999",
      "priceFormatted": "R$79.999,00",
      "passions": [
        "sports",
        "movies",
        "smart",
      ],
      "image": {
        "src": QN900B,
        "thumbnail": QN900B,
        "alt": "QN900B de 85 polegadas "
      },
      "features": [
          "8K",
          "smart8K"
      ],
      "specs": {
          "thickness": "1.5cm|Teste",
          "border": "Sem Borda",
          "singleConnection": "Sim",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "8K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Altíssimo",
          "brightness": "Altíssimo",
          "processor": "Quantum 8K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "PRO",
          "soundPower": "90W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN65QN800BGXZD": {
      "sku": "QN65QN800BGXZD",
      "size": "65",
      "displayName": "QN800",
      "cardColor": "#212D9B",
      "family": "Neo QLED 8K",
      "description": "Samsung Smart TV 65\" Neo QLED 8K QN800B 2022, Mini Led, Painel 120hz, Processador com IA, Som em Movimento, Tela sem limites, Ultrafina, Única Conexão, Alexa Built-in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn800b-65-inch-neo-qled-8k-smart-tv-qn65qn800bgxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN800BGXZDPDP-SSG-LANDINGPAGE-NA-NALP849854SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN800BGXZDPDP-SSG-LANDINGPAGE-NA-NALP849854SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-2044/p?skuId=2910",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-2044/p?skuId=2910&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN800BGXZD-SSG-LANDINGPAGE-NA-NALP286210SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN800BGXZD-SSG-LANDINGPAGE-NA-NALP286210SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2910&qty=1&seller=samsung&sc=1&sku=2917&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2910&2917-SSG-LANDINGPAGE-NA-NALP1718576SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2910&2917-SSG-LANDINGPAGE-NA-NALP1718415SRC-NA&keeplink=true",
      "price": "13299",
      "priceFormatted": "R$13.299,00",
      "passions": [
        "sports",
        "movies",
        "smart",
      ],
      "image": {
        "src": QN800B,
        "thumbnail": QN800B,
        "alt": "QN800B de 65 polegadas"
      },
      "features": [
          "8K",
          "smart8K"
      ],
      "specs": {
          "thickness": "1.7cm",
          "border": "Infinita",
          "singleConnection": "Sim",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "8K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Muito Alto",
          "brightness": "Muito Alto",
          "processor": "Quantum 8K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "PLUS",
          "soundPower": "70W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN75QN800BGXZD": {
      "sku": "QN75QN800BGXZD",
      "size": "75",
      "displayName": "QN800",
      "cardColor": "#212D9B",
      "family": "Neo QLED 8K",
      "description": "Samsung Smart TV 75\" Neo QLED 8K QN800B 2022, Mini Led, Painel 120hz, Processador com IA, Som em Movimento, Tela sem limites, Ultrafina, Única Conexão, Alexa Built-in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn800b-75-inch-neo-qled-8k-smart-tv-qn75qn800bgxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN800BGXZDPDP-SSG-LANDINGPAGE-NA-NALP849855SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN800BGXZDPDP-SSG-LANDINGPAGE-NA-NALP849855SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-2044/p?skuId=2911",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-2044/p?skuId=2911&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN800BGXZD-SSG-LANDINGPAGE-NA-NALP286211SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN800BGXZD-SSG-LANDINGPAGE-NA-NALP286211SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2911&qty=1&seller=samsung&sc=1&sku=2917&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2911&2917-SSG-LANDINGPAGE-NA-NALP1718577SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2911&2917-SSG-LANDINGPAGE-NA-NALP1718416SRC-NA&keeplink=true",
      "price": "22799",
      "priceFormatted": "R$22.799,00",
      "passions": [
        "sports",
        "movies",
        "smart",
      ],
      "image": {
        "src": QN800B,
        "thumbnail": QN800B,
        "alt": "QN800B de 75 polegadas"
      },
      "features": [
          "8K",
          "smart8K"
      ],
      "specs": {
          "thickness": "1.7cm",
          "border": "Infinita",
          "singleConnection": "Sim",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "8K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Muito Alto",
          "brightness": "Muito Alto",
          "processor": "Quantum 8K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "PLUS",
          "soundPower": "70W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN85QN800BGXZD": {
      "sku": "QN85QN800BGXZD",
      "size": "85",
      "displayName": "QN800",
      "cardColor": "#212D9B",
      "family": "Neo QLED 8K",
      "description": "Samsung Smart TV 85\" Neo QLED 8K QN800B 2022, Mini Led, Painel 120hz, Processador com IA, Som em Movimento, Tela sem limites, Ultrafina, Única Conexão, Alexa Built-in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn800b-85-inch-neo-qled-8k-smart-tv-qn85qn800bgxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN800BGXZDPDP-SSG-LANDINGPAGE-NA-NALP849856SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN800BGXZDPDP-SSG-LANDINGPAGE-NA-NALP849856SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-2044/p?skuId=2912",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-2044/p?skuId=2912&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN800BGXZD-SSG-LANDINGPAGE-NA-NALP286212SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN800BGXZD-SSG-LANDINGPAGE-NA-NALP286212SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2912&qty=1&seller=samsung&sc=1&sku=2917&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2912&2917-SSG-LANDINGPAGE-NA-NALP1718578SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2912&2917-SSG-LANDINGPAGE-NA-NALP1718417SRC-NA&keeplink=true",
      "price": "49999",
      "priceFormatted": "R$49.999,00",
      "passions": [
        "sports",
        "movies",
        "smart",
      ],
      "image": {
        "src": QN800B,
        "thumbnail": QN800B,
        "alt": "QN800B de 85 polegadas"
      },
      "features": [
          "8K",
          "smart8K"
      ],
      "specs": {
          "thickness": "1.7cm",
          "border": "Infinita",
          "singleConnection": "Sim",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "8K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Muito Alto",
          "brightness": "Muito Alto",
          "processor": "Quantum 8K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "PLUS",
          "soundPower": "70W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN43QN90BAGXZD": {
      "sku": "QN43QN90BAGXZD",
      "size": "43",
      "displayName": "QN90",
      "cardColor": "#192CDB",
      "family": "Neo QLED",
      "description": "Samsung Smart Gaming TV Neo QLED 4K QN90B 43\" 2022, Mini Led, Painel  144hz, Processador com IA, Tela Ultrawide e Menu de Jogosl, Freesync VRR, Som em Movimento Virtual, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn90b-43-inch-neo-qled-4k-smart-tv-qn43qn90bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN43QN90BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849859SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN43QN90BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849859SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-gaming-tv-2049/p?skuId=2918",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-gaming-tv-2049/p?skuId=2918&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN43QN90BAGXZD -SSG-LANDINGPAGE-NA-NALP286215SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN43QN90BAGXZD -SSG-LANDINGPAGE-NA-NALP286215SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2918&qty=1&seller=samsung&sc=1&sku=2916&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2918&2916-SSG-LANDINGPAGE-NA-NALP1718579SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2918&2916-SSG-LANDINGPAGE-NA-NALP1718418SRC-NA&keeplink=true",
      "price": "4599",
      "priceFormatted": "R$4.599,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
      ],
      "image": {
        "src": QN90B,
        "thumbnail": QN90B,
        "alt": "QN90B de 43 polegadas"
      },
      "features": [
          "vividColor",
          "console",
          "pc",
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Muito Alto<sup>11</sup>",
          "brightness": "Muito Alto<sup>11</sup>",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "Até 144Hz<sup>1</sup>",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "PLUS",
          "soundPower": "Até 60W<sup>13</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN50QN90BAGXZD": {
      "sku": "QN50QN90BAGXZD",
      "size": "50",
      "displayName": "QN90",
      "cardColor": "#192CDB",
      "family": "Neo QLED",
      "description": "Samsung Smart Gaming TV Neo QLED 4K QN90B 50\" 2022, Mini Led, Painel 144hz, Processador com IA, Tela Ultrawide e Menu de Jogosl, Freesync VRR, Som em Movimento Virtual, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn90b-50-inch-neo-qled-4k-smart-tv-qn50qn90bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50QN90BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849860SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50QN90BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849860SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-gaming-tv-2049/p?skuId=2919",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-gaming-tv-2049/p?skuId=2919&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50QN90BAGXZD -SSG-LANDINGPAGE-NA-NALP286216SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50QN90BAGXZD -SSG-LANDINGPAGE-NA-NALP286216SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2919&qty=1&seller=samsung&sc=1&sku=2916&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2919&2916-SSG-LANDINGPAGE-NA-NALP1718580SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2919&2916-SSG-LANDINGPAGE-NA-NALP1718419SRC-NA&keeplink=true",
      "price": "4849",
      "priceFormatted": "R$4.849,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
      ],
      "image": {
        "src": QN90B,
        "thumbnail": QN90B,
        "alt": "QN90B de 50 polegadas"
      },
      "features": [
          "vividColor",
          "console",
          "pc",
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Muito Alto<sup>11</sup>",
          "brightness": "Muito Alto<sup>11</sup>",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "Até 144Hz<sup>1</sup>",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "PLUS",
          "soundPower": "Até 60W<sup>13</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN55QN90BAGXZD": {
      "sku": "QN55QN90BAGXZD",
      "size": "55",
      "displayName": "QN90",
      "cardColor": "#192CDB",
      "family": "Neo QLED",
      "description": "Samsung Smart Gaming TV Neo QLED 4K QN90B 55\" 2022, Mini Led, Painel  120Hz, Processador com IA, Tela Ultrawide e Menu de Jogosl, Freesync VRR, Som em Movimento, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn90b-55-inch-neo-qled-4k-smart-tv-qn55qn90bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55QN90BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849861SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55QN90BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849861SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-gaming-tv-2049/p?skuId=2920",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-gaming-tv-2049/p?skuId=2920&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55QN90BAGXZD-SSG-LANDINGPAGE-NA-NALP286217SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55QN90BAGXZD-SSG-LANDINGPAGE-NA-NALP286217SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2920&qty=1&seller=samsung&sc=1&sku=2916&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2920&2916-SSG-LANDINGPAGE-NA-NALP1718581SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2920&2916-SSG-LANDINGPAGE-NA-NALP1718420SRC-NA&keeplink=true",
      "price": "6699",
      "priceFormatted": "R$6.699,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
      ],
      "image": {
        "src": QN90B,
        "thumbnail": QN90B,
        "alt": "QN90B de 55 polegadas"
      },
      "features": [
          "vividColor",
          "console",
          "pc",
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Muito Alto<sup>11</sup>",
          "brightness": "Muito Alto<sup>11</sup>",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "Até 144Hz<sup>1</sup>",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "PLUS",
          "soundPower": "Até 60W<sup>13</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN65QN90BAGXZD": {
      "sku": "QN65QN90BAGXZD",
      "size": "65",
      "displayName": "QN90",
      "cardColor": "#192CDB",
      "family": "Neo QLED",
      "description": "Samsung Smart Gaming TV Neo QLED 4K QN90B 65\" 2022, Mini Led, Painel  120Hz, Processador com IA, Tela Ultrawide e Menu de Jogosl, Freesync VRR, Som em Movimento, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn90b-65-inch-neo-qled-4k-smart-tv-qn65qn90bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN90BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849862SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN90BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849862SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-gaming-tv-2049/p?skuId=2921",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-gaming-tv-2049/p?skuId=2921&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN90BAGXZD-SSG-LANDINGPAGE-NA-NALP286218SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN90BAGXZD-SSG-LANDINGPAGE-NA-NALP286218SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2921&qty=1&seller=samsung&sc=1&sku=2916&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2921&2916-SSG-LANDINGPAGE-NA-NALP1718582SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2921&2916-SSG-LANDINGPAGE-NA-NALP1718421SRC-NA&keeplink=true",
      "price": "10499",
      "priceFormatted": "R$10.499,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
      ],
      "image": {
        "src": QN90B,
        "thumbnail": QN90B,
        "alt": "QN90B de 65 polegadas"
      },
      "features": [
          "vividColor",
          "console",
          "pc",
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Muito Alto<sup>11</sup>",
          "brightness": "Muito Alto<sup>11</sup>",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "Até 144Hz<sup>1</sup>",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "PLUS",
          "soundPower": "Até 60W<sup>13</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN55QN85BAGXZD": {
      "sku": "QN55QN85BAGXZD",
      "size": "55",
      "displayName": "QN85",
      "cardColor": "#192CDB",
      "family": "Neo QLED",
      "description": "Samsung Smart TV 55\" Neo QLED 4K QN85B 2022, Mini Led, Painel 120hz, Processador com IA, Som em Movimento, Tela sem limites, Design slim, Alexa built in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn85b-55-inch-neo-qled-4k-smart-tv-qn55qn85bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50QN85BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849863SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50QN85BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849863SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qn85bagxzd/p?skuId=2906",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qn85bagxzd/p?skuId=2906&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55QN85BAGXZD -SSG-LANDINGPAGE-NA-NALP286219SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55QN85BAGXZD -SSG-LANDINGPAGE-NA-NALP286219SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2906&qty=1&seller=samsung&sc=1&sku=3030&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2906&3030-SSG-LANDINGPAGE-NA-NALP1718583SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2906&3030-SSG-LANDINGPAGE-NA-NALP1718422SRC-NA&keeplink=true",
      "price": "5699",
      "priceFormatted": "R$5.699,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": QN85B,
        "thumbnail": QN85B,
        "alt": "QN85B de 55 polegadas"
      },
      "features": [
          "vividColor",
          "console",
          "pc",
          "cloud",
          "videocall"
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Alto",
          "brightness": "Alto",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "Sim",
          "soundPower": "60W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN65QN85BAGXZD": {
      "sku": "QN65QN85BAGXZD",
      "size": "65",
      "displayName": "QN85",
      "cardColor": "#192CDB",
      "family": "Neo QLED",
      "description": "Samsung Smart TV 65\" Neo QLED 4K QN85B 2022, Mini Led, Painel 120hz, Processador com IA, Som em Movimento, Tela sem limites, Design slim, Alexa built in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn85b-65-inch-neo-qled-4k-smart-tv-qn65qn85bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN85BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849864SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN85BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849864SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qn85bagxzd/p?skuId=2907",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qn85bagxzd/p?skuId=2907&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN85BAGXZD-SSG-LANDINGPAGE-NA-NALP286220SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65QN85BAGXZD-SSG-LANDINGPAGE-NA-NALP286220SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2907&qty=1&seller=samsung&sc=1&sku=3030&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2907&3030-SSG-LANDINGPAGE-NA-NALP1718584SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2907&3030-SSG-LANDINGPAGE-NA-NALP1718423SRC-NA&keeplink=true",
      "price": "8949",
      "priceFormatted": "R$8.949,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": QN85B,
        "thumbnail": QN85B,
        "alt": "QN65QN800BGXZD"
      },
      "features": [
          "vividColor",
          "console",
          "pc",
          "cloud",
          "videocall"
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Alto",
          "brightness": "Alto",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "Sim",
          "soundPower": "60W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN75QN85BAGXZD": {
      "sku": "QN75QN85BAGXZD",
      "size": "75",
      "displayName": "QN85",
      "cardColor": "#192CDB",
      "family": "Neo QLED",
      "description": "Samsung Smart TV 75\" Neo QLED 4K QN85B 2022, Mini Led, Painel 120hz, Processador com IA, Som em Movimento, Tela sem limites, Design slim, Alexa built in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn85b-75-inch-neo-qled-4k-smart-tv-qn75qn85bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN85BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849865SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN85BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849865SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qn85bagxzd/p?skuId=2908",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qn85bagxzd/p?skuId=2908&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN85BAGXZD-SSG-LANDINGPAGE-NA-NALP286221SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75QN85BAGXZD-SSG-LANDINGPAGE-NA-NALP286221SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2908&qty=1&seller=samsung&sc=1&sku=3030&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2908&3030-SSG-LANDINGPAGE-NA-NALP1718585SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2908&3030-SSG-LANDINGPAGE-NA-NALP1718424SRC-NA&keeplink=true",
      "price": "13299",
      "priceFormatted": "R$13.299,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": QN85B,
        "thumbnail": QN85B,
        "alt": "QN65QN800BGXZD"
      },
      "features": [
          "vividColor",
          "console",
          "pc",
          "cloud",
          "videocall"
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Alto",
          "brightness": "Alto",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "Sim",
          "soundPower": "60W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN85QN85BAGXZD": {
      "sku": "QN85QN85BAGXZD",
      "size": "85",
      "displayName": "QN85",
      "cardColor": "#192CDB",
      "family": "Neo QLED",
      "description": "Samsung Smart TV 85\" Neo QLED 4K QN85B 2022, Mini Led, Painel 120hz, Processador com IA, Som em Movimento, Tela sem limites, Design slim, Alexa built in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/qn85b-85-inch-neo-qled-4k-smart-tv-qn85qn85bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN85BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849866SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN85BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849866SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qn85bagxzd/p?skuId=2909",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qn85bagxzd/p?skuId=2909&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN85BAGXZD-SSG-LANDINGPAGE-NA-NALP286222SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85QN85BAGXZD-SSG-LANDINGPAGE-NA-NALP286222SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2909&qty=1&seller=samsung&sc=1&sku=3030&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2909&3030-SSG-LANDINGPAGE-NA-NALP1718586SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2909&3030-SSG-LANDINGPAGE-NA-NALP1718425SRC-NA&keeplink=true",
      "price": "26999",
      "priceFormatted": "R$26.999,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": QN85B,
        "thumbnail": QN85B,
        "alt": "QN85B de 85 polegadas"
      },
      "features": [
          "vividColor",
          "console",
          "pc",
          "cloud",
          "videocall"
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD Mini LED|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Alto",
          "brightness": "Alto",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas",
          "dolbyAtmos": "Sim",
          "movingSound": "Sim",
          "soundPower": "60W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN50Q80BAGXZD": {
      "sku": "QN50Q80BAGXZD",
      "size": "50",
      "displayName": "Q80",
      "cardColor": "#4276C4",
      "family": "QLED",
      "description": "Samsung Smart TV 50\" QLED 4K Q80B 2022, Modo Game, Processador com IA, Som em Movimento Virtual, Tela sem limites, Visual livre de cabos, Alexa built in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/q80b-50-inch-qled-4k-smart-tv-qn50q80bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50Q80BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP871743SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50Q80BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP871743SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-2003/p?skuId=2842",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-2003/p?skuId=2842&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50Q80BAGXZD-SSG-LANDINGPAGE-NA-NALP286223SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50Q80BAGXZD-SSG-LANDINGPAGE-NA-NALP286223SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2842&qty=1&seller=samsung&sc=1&sku=2915&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2842&2915-SSG-LANDINGPAGE-NA-NALP1718587SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2842&2915-SSG-LANDINGPAGE-NA-NALP1718426SRC-NA&keeplink=true",
      "price": "4099",
      "priceFormatted": "R$4.099,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": Q80B,
        "thumbnail": Q80B,
        "alt": "Q80B de 50 polegadas"
      },
      "features": [
          "immersiveSound",
          "console",
          "pc",
          "cloud",
          "smarthome",
          "videocall"
      ],
      "specs": {
          "thickness": "5.4cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD 100%|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Médio",
          "brightness": "Médio",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "Até 120Hz<sup>2</sup>",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas<sup>3</sup>",
          "dolbyAtmos": "Sim",
          "movingSound": "Sim",
          "soundPower": "Até 60W<sup>12</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN55Q80BAGXZD": {
      "sku": "QN55Q80BAGXZD",
      "size": "55",
      "displayName": "Q80",
      "cardColor": "#192CDB",
      "family": "QLED",
      "description": "Samsung Smart TV 55\" QLED 4K Q80B 2022, Modo Game, Processador com IA, Som em Movimento, Tela sem limites, Visual livre de cabos, Alexa built in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/q80b-55-inch-qled-4k-smart-tv-qn55q80bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q80BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849868SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q80BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849868SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-2003/p?skuId=2843",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-2003/p?skuId=2843&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q80BAGXZD-SSG-LANDINGPAGE-NA-NALP286224SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q80BAGXZD-SSG-LANDINGPAGE-NA-NALP286224SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2843&qty=1&seller=samsung&sc=1&sku=2915&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2843&2915-SSG-LANDINGPAGE-NA-NALP1718588SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2843&2915-SSG-LANDINGPAGE-NA-NALP1718427SRC-NA&keeplink=true",
      "price": "5249",
      "priceFormatted": "R$5.249,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": Q80B,
        "thumbnail": Q80B,
        "alt": "Q80B de 55 polegadas"
      },
      "features": [
          "immersiveSound",
          "console",
          "pc",
          "cloud",
          "smarthome",
          "videocall"
      ],
      "specs": {
          "thickness": "5.4cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD 100%|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Médio",
          "brightness": "Médio",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "Até 120Hz<sup>2</sup>",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas<sup>3</sup>",
          "dolbyAtmos": "Sim",
          "movingSound": "Sim",
          "soundPower": "Até 60W<sup>12</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN65Q80BAGXZD": {
      "sku": "QN65Q80BAGXZD",
      "size": "65",
      "displayName": "Q80",
      "cardColor": "#192CDB",
      "family": "QLED",
      "description": "Samsung Smart TV 65\" QLED 4K Q80B 2022, Modo Game, Processador com IA, Som em Movimento, Tela sem limites, Visual livre de cabos, Alexa built in, Dolby Atmos",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/q80b-65-inch-qled-4k-smart-tv-qn65q80bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q80BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849869SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q80BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849869SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-2003/p?skuId=2844",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-2003/p?skuId=2844&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q80BAGXZD-SSG-LANDINGPAGE-NA-NALP286225SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q80BAGXZD-SSG-LANDINGPAGE-NA-NALP286225SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2844&qty=1&seller=samsung&sc=1&sku=2915&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2844&2915-SSG-LANDINGPAGE-NA-NALP1718589SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2844&2915-SSG-LANDINGPAGE-NA-NALP1718428SRC-NA&keeplink=true",
      "price": "6699",
      "priceFormatted": "R$6.699,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": Q80B,
        "thumbnail": Q80B,
        "alt": "Q80B de 65 polegadas"
      },
      "features": [
          "immersiveSound",
          "console",
          "pc",
          "cloud",
          "smarthome",
          "videocall"
      ],
      "specs": {
          "thickness": "5.4cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD 100%|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Médio",
          "brightness": "Médio",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "Até 120Hz<sup>2</sup>",
          "freesync": "Sim",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "4 portas<sup>3</sup>",
          "dolbyAtmos": "Sim",
          "movingSound": "Sim",
          "soundPower": "Até 60W<sup>12</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN55Q70AAGXZD": {
      "sku": "QN55Q70AAGXZD",
      "size": "55",
      "displayName": "Q70",
      "cardColor": "#4276C4",
      "family": "QLED",
      "description": "Samsung  Smart TV 55\" QLED 4K Q70A, Modo Game, Processador IA, Som em Movimento  Virtual, Tela sem limites, Design slim, Alexa built in",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/q70a-55-inch-qled-4k-smart-tv-qn55q70aagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q70AAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849878SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q70AAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849878SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-q70a/p?skuId=1940",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-q70a/p?skuId=1940&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q70AAGXZD-SSG-LANDINGPAGE-NA-NALP286234SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q70AAGXZD-SSG-LANDINGPAGE-NA-NALP286234SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=1940&qty=1&seller=samsung&sc=1&sku=2916&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-1940&2916-SSG-LANDINGPAGE-NA-NALP1718590SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-1940&2916-SSG-LANDINGPAGE-NA-NALP1718429SRC-NA&keeplink=true",
      "price": "4299",
      "priceFormatted": "R$4.299,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": Q70A,
        "thumbnail": Q70A,
        "alt": "Q70A de 55 polegadas"
      },
      "features": [
          "immersiveSound",
          "console",
          "pc",
          "smarthome",
          "videocall"
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD 100%|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Médio",
          "brightness": "Médio",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "-",
          "gamingHub": "-",
          "hdmi": "1 porta",
          "dolbyAtmos": "-",
          "movingSound": "Virtual",
          "soundPower": "20W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN65Q70AAGXZD": {
      "sku": "QN65Q70AAGXZD",
      "size": "65",
      "displayName": "Q70",
      "cardColor": "#4276C4",
      "family": "QLED",
      "description": "Samsung Smart  TV 65\" QLED 4K Q70A, Modo Game, Processador IA, Som em Movimento  Virtual, Tela sem limites, Design slim, Alexa built in",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/q70a-65-inch-qled-4k-smart-tv-qn65q70aagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q70AAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849879SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q70AAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849879SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-q70a/p?skuId=1941",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-q70a/p?skuId=1941&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q70AAGXZD-SSG-LANDINGPAGE-NA-NALP286235SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q70AAGXZD-SSG-LANDINGPAGE-NA-NALP286235SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=1941&qty=1&seller=samsung&sc=1&sku=2916&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-1941&2916-SSG-LANDINGPAGE-NA-NALP1718591SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-1941&2916-SSG-LANDINGPAGE-NA-NALP1718430SRC-NA&keeplink=true",
      "price": "6199",
      "priceFormatted": "R$6.199,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": Q70A,
        "thumbnail": Q70A,
        "alt": "Q70A de 65 polegadas"
      },
      "features": [
          "immersiveSound",
          "console",
          "pc",
          "smarthome",
          "videocall"
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD 100%|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Médio",
          "brightness": "Médio",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "-",
          "gamingHub": "-",
          "hdmi": "1 porta",
          "dolbyAtmos": "-",
          "movingSound": "Virtual",
          "soundPower": "20W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN75Q70AAGXZD": {
      "sku": "QN75Q70AAGXZD",
      "size": "75",
      "displayName": "Q70",
      "cardColor": "#4276C4",
      "family": "QLED",
      "description": "Samsung Smart  TV 75\" QLED 4K Q70A, Modo Game, Processador IA, Som em Movimento  Virtual, Tela sem limites, Design slim, Alexa built in",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/q70a-75-inch-qled-4k-smart-tv-qn75q70aagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75Q70AAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849880SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75Q70AAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849880SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-q70a/p?skuId=1942",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-q70a/p?skuId=1942&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75Q70AAGXZD-SSG-LANDINGPAGE-NA-NALP286236SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75Q70AAGXZD-SSG-LANDINGPAGE-NA-NALP286236SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=1942&qty=1&seller=samsung&sc=1&sku=2916&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-1942&2916-SSG-LANDINGPAGE-NA-NALP1718592SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-1942&2916-SSG-LANDINGPAGE-NA-NALP1718431SRC-NA&keeplink=true",
      "price": "9499",
      "priceFormatted": "R$9.499,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": Q70A,
        "thumbnail": Q70A,
        "alt": "Q70A de 75 polegadas"
      },
      "features": [
          "immersiveSound",
          "console",
          "pc",
          "smarthome",
          "videocall"
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD 100%|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Médio",
          "brightness": "Médio",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "-",
          "gamingHub": "-",
          "hdmi": "1 porta",
          "dolbyAtmos": "-",
          "movingSound": "Virtual",
          "soundPower": "20W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN85Q70AAGXZD": {
      "sku": "QN85Q70AAGXZD",
      "size": "85",
      "displayName": "Q70",
      "cardColor": "#4276C4",
      "family": "QLED",
      "description": "Samsung Smart  TV 85\" QLED 4K Q70A,  Modo Game,  Processador IA, Som em Movimento Virtual, Tela sem limites, Design slim,  Alexa built in",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/q70a-85-inch-qled-4k-smart-tv-qn85q70aagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85Q70AAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849881SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85Q70AAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849881SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-q70a/p?skuId=1943",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-q70a/p?skuId=1943&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85Q70AAGXZD-SSG-LANDINGPAGE-NA-NALP286237SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85Q70AAGXZD-SSG-LANDINGPAGE-NA-NALP286237SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=1943&qty=1&seller=samsung&sc=1&sku=2916&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-1943&2916-SSG-LANDINGPAGE-NA-NALP1718593SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-1943&2916-SSG-LANDINGPAGE-NA-NALP1718432SRC-NA&keeplink=true",
      "price": "13499",
      "priceFormatted": "R$13.499,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": Q70A,
        "thumbnail": Q70A,
        "alt": "Q70A de 85 polegadas"
      },
      "features": [
          "immersiveSound",
          "console",
          "pc",
          "smarthome",
          "videocall"
      ],
      "specs": {
          "thickness": "Até 2.7cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD 100%|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Médio",
          "brightness": "Médio",
          "processor": "Quantum 4K IA|Inteligência Artificial",
          "frequency": "120Hz",
          "freesync": "Sim",
          "ultrawide": "-",
          "gamingHub": "-",
          "hdmi": "1 porta",
          "dolbyAtmos": "-",
          "movingSound": "Virtual",
          "soundPower": "20W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "Sim",
          "googleduo": "Sim",
          "smartcam": "Sim"
      }
  },
  "QN50Q60BAGXZD": {
      "sku": "QN50Q60BAGXZD",
      "size": "50",
      "displayName": "Q60",
      "cardColor": "#4276C4",
      "family": "QLED",
      "description": "Samsung Smart TV 50\" QLED 4K Q60B 2022, Modo Game, Som em Movimento, Tela sem limites, Design slim, Visual livre de cabos, Alexa built in",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/q60b-50-inch-qled-4k-smart-tv-qn50q60bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50Q60BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849875SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50Q60BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849875SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv--qled-4k-q60b-2022-1932/p?skuId=2709",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv--qled-4k-q60b-2022-1932/p?skuId=2709&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50Q60BAGXZD-SSG-LANDINGPAGE-NA-NALP286231SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50Q60BAGXZD-SSG-LANDINGPAGE-NA-NALP286231SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2709&qty=1&seller=samsung&sc=1&sku=2916&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2709&2916-SSG-LANDINGPAGE-NA-NALP1718594SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2709&2916-SSG-LANDINGPAGE-NA-NALP1718433SRC-NA&keeplink=true",
      "price": "3349",
      "priceFormatted": "R$3.349,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": Q60B,
        "thumbnail": Q60B,
        "alt": "Q60B de 50 polegadas"
      },
      "features": [
          "immersiveSound",
          "cloud",
          "smarthome",
          "videocall"
      ],
      "specs": {
          "thickness": "2.6cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD 100%|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Médio",
          "brightness": "Médio",
          "processor": "Quantum 4K",
          "frequency": "60Hz",
          "freesync": "-",
          "ultrawide": "-",
          "gamingHub": "Sim",
          "hdmi": "0",
          "dolbyAtmos": "-",
          "movingSound": "Virtual",
          "soundPower": "20W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "-",
          "googleduo": "Sim",
          "smartcam": "-"
      }
  },
  "QN55Q60BAGXZD": {
      "sku": "QN55Q60BAGXZD",
      "size": "55",
      "displayName": "Q60",
      "cardColor": "#4276C4",
      "family": "QLED",
      "description": "Samsung Smart TV 55\" QLED 4K Q60B 2022, Modo Game, Som em Movimento, Tela sem limites, Design slim, Visual livre de cabos, Alexa built in",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/q60b-55-inch-qled-4k-smart-tv-qn55q60bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q60BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849876SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q60BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849876SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv--qled-4k-q60b-2022-1932/p?skuId=2710",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv--qled-4k-q60b-2022-1932/p?skuId=2710&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q60BAGXZD-SSG-LANDINGPAGE-NA-NALP286232SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55Q60BAGXZD-SSG-LANDINGPAGE-NA-NALP286232SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2710&qty=1&seller=samsung&sc=1&sku=2916&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2710&2916-SSG-LANDINGPAGE-NA-NALP1718595SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2710&2916-SSG-LANDINGPAGE-NA-NALP1718434SRC-NA&keeplink=true",
      "price": "3999",
      "priceFormatted": "R$3.999,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": Q60B,
        "thumbnail": Q60B,
        "alt": "Q60B de 55 polegadas"
      },
      "features": [
          "immersiveSound",
          "cloud",
          "smarthome",
          "videocall"
      ],
      "specs": {
          "thickness": "2.6cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD 100%|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Médio",
          "brightness": "Médio",
          "processor": "Quantum 4K",
          "frequency": "60Hz",
          "freesync": "-",
          "ultrawide": "-",
          "gamingHub": "Sim",
          "hdmi": "0",
          "dolbyAtmos": "-",
          "movingSound": "Virtual",
          "soundPower": "20W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "-",
          "googleduo": "Sim",
          "smartcam": "-"
      }
  },
  "QN65Q60BAGXZD": {
      "sku": "QN65Q60BAGXZD",
      "size": "65",
      "displayName": "Q60",
      "cardColor": "#4276C4",
      "family": "QLED",
      "description": "Samsung Smart TV 65\" QLED 4K Q60B 2022, Modo Game, Som em Movimento, Tela sem limites, Design slim, Visual livre de cabos, Alexa built in",
      "pdpUrl": "https://www.samsung.com/br/tvs/qled-tv/q60b-65-inch-qled-4k-smart-tv-qn65q60bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q60BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849877SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q60BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849877SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv--qled-4k-q60b-2022-1932/p?skuId=2711",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv--qled-4k-q60b-2022-1932/p?skuId=2711&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q60BAGXZD-SSG-LANDINGPAGE-NA-NALP286233SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65Q60BAGXZD-SSG-LANDINGPAGE-NA-NALP286233SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2711&qty=1&seller=samsung&sc=1&sku=2916&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2711&2916-SSG-LANDINGPAGE-NA-NALP1718596SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2711&2916-SSG-LANDINGPAGE-NA-NALP1718435SRC-NA&keeplink=true",
      "price": "5249",
      "priceFormatted": "R$5.249,00",
      "passions": [
        "sports",
        "gaming",
        "movies",
        "smart"
      ],
      "image": {
        "src": Q60B,
        "thumbnail": Q60B,
        "alt": "Q60B de 65 polegadas"
      },
      "features": [
          "immersiveSound",
          "cloud",
          "smarthome",
          "videocall"
      ],
      "specs": {
          "thickness": "2.6cm",
          "border": "Infinita",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QD 100%|QD: Quantum Dots - Pontos Quânticos",
          "contrast": "Médio",
          "brightness": "Médio",
          "processor": "Quantum 4K",
          "frequency": "60Hz",
          "freesync": "-",
          "ultrawide": "-",
          "gamingHub": "Sim",
          "hdmi": "0",
          "dolbyAtmos": "-",
          "movingSound": "Virtual",
          "soundPower": "20W",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "-",
          "googleduo": "Sim",
          "smartcam": "-"
      }
  },
  "UN43BU8000GXZD": {
    "sku": "UN43BU8000GXZD",
    "size": "43",
    "displayName": "BU8000",
    "cardColor": "#4276C4",
    "family": "Crystal UHD",
    "description": "Samsung Smart TV 43\" Crystal UHD 4K BU8000 2022, Painel Dynamic Crystal Color, Design slim, Tela sem limites, Alexa built in, Controle Remoto Único",
    "pdpUrl": "https://www.samsung.com/br/tvs/uhd-4k-tv/bu8000-43-inch-crystal-uhd-4k-smart-tv-un43bu8000gxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN43BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849890SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN43BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849890SRC-NA&keeplink=true",
    "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2755",
    "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2755&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN43BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286246SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN43BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286246SRC-NA&keeplink=true",
    "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2755&qty=1&seller=samsung&sc=1&sku=2452&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2755&2452-SSG-LANDINGPAGE-NA-NALP1718597SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2755&2452-SSG-LANDINGPAGE-NA-NALP1718436SRC-NA&keeplink=true",
    "price": "2299",
    "priceFormatted": "R$2.299,00",
    "passions": [
      "sports",
      "gaming",
      "movies",
      "smart"
    ],
    "image": {
      "src": BU8000,
      "thumbnail": BU8000,
      "alt": "BU8000 de 43 polegadas"
    },
    "features": [
        "smootherMotion",
        "cloud",
        "smarthome"
    ],
    "specs": {
        "thickness": "Até 2.7cm",
        "border": "Infinita",
        "singleConnection": "-",
        "displayMasterpiece": "-",
        "beautiful": "-",
        "vertical": "-",
        "portable": "-",
        "resolution": "4K",
        "colorVolume": "Crystal",
        "contrast": "Normal",
        "brightness": "Normal",
        "processor": "Quantum 4K",
        "frequency": "60Hz",
        "freesync": "-",
        "ultrawide": "-",
        "gamingHub": "Sim",
        "hdmi": "0",
        "dolbyAtmos": "-",
        "movingSound": "Virtual",
        "soundPower": "20W",
        "smartThings": "Sim",
        "alexa": "Sim",
        "bixby": "Sim",
        "handsfree": "-",
        "googleduo": "-",
        "smartcam": "-"
    }
  },
  "UN50BU8000GXZD": {
    "sku": "UN50BU8000GXZD",
    "size": "50",
    "displayName": "BU8000",
    "cardColor": "#4276C4",
    "family": "Crystal UHD",
    "description": "Samsung Smart TV 50\" Crystal UHD 4K BU8000 2022, Painel Dynamic Crystal Color, Design slim, Tela sem limites, Visual Livre de Cabos, Alexa built in, Controle Remoto Único",
    "pdpUrl": "https://www.samsung.com/br/tvs/uhd-4k-tv/bu8000-50-inch-crystal-uhd-4k-smart-tv-un50bu8000gxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN50BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849891SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN50BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849891SRC-NA&keeplink=true",
    "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2756",
    "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2756&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN50BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286247SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN50BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286247SRC-NA&keeplink=true",
    "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2756&qty=1&seller=samsung&sc=1&sku=2452&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2756&2452-SSG-LANDINGPAGE-NA-NALP1718598SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2756&2452-SSG-LANDINGPAGE-NA-NALP1718437SRC-NA&keeplink=true",
    "price": "2899",
    "priceFormatted": "R$2.899,00",
    "passions": [
      "sports",
      "gaming",
      "movies",
      "smart"
    ],
    "image": {
      "src": BU8000,
      "thumbnail": BU8000,
      "alt": "BU8000 de 50 polegadas"
    },
    "features": [
        "smootherMotion",
        "cloud",
        "smarthome"
    ],
    "specs": {
        "thickness": "Até 2.7cm",
        "border": "Infinita",
        "singleConnection": "-",
        "displayMasterpiece": "-",
        "beautiful": "-",
        "vertical": "-",
        "portable": "-",
        "resolution": "4K",
        "colorVolume": "Crystal",
        "contrast": "Normal",
        "brightness": "Normal",
        "processor": "Quantum 4K",
        "frequency": "60Hz",
        "freesync": "-",
        "ultrawide": "-",
        "gamingHub": "Sim",
        "hdmi": "0",
        "dolbyAtmos": "-",
        "movingSound": "Virtual",
        "soundPower": "20W",
        "smartThings": "Sim",
        "alexa": "Sim",
        "bixby": "Sim",
        "handsfree": "-",
        "googleduo": "-",
        "smartcam": "-"
    }
  },
  "UN55BU8000GXZD": {
    "sku": "UN55BU8000GXZD",
    "size": "55",
    "displayName": "BU8000",
    "cardColor": "#4276C4",
    "family": "Crystal UHD",
    "description": "Samsung Smart TV 55\" Crystal UHD 4K BU8000 2022, Painel Dynamic Crystal Color, Design slim, Tela sem limites, Visual Livre de Cabos, Alexa built in, Controle Remoto Único",
    "pdpUrl": "https://www.samsung.com/br/tvs/uhd-4k-tv/bu8000-55-inch-crystal-uhd-4k-smart-tv-un55bu8000gxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN55BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849892SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN55BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849892SRC-NA&keeplink=true",
    "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2757",
    "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2757&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN55BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286248SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN55BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286248SRC-NA&keeplink=true",
    "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2757&qty=1&seller=samsung&sc=1&sku=2452&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2757&2452-SSG-LANDINGPAGE-NA-NALP1718599SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2757&2452-SSG-LANDINGPAGE-NA-NALP1718438SRC-NA&keeplink=true",
    "price": "3249",
    "priceFormatted": "R$3.249,00",
    "passions": [
      "sports",
      "gaming",
      "movies",
      "smart"
    ],
    "image": {
      "src": BU8000,
      "thumbnail": BU8000,
      "alt": "BU8000 de 55 polegadas"
    },
    "features": [
        "smootherMotion",
        "cloud",
        "smarthome"
    ],
    "specs": {
        "thickness": "Até 2.7cm",
        "border": "Infinita",
        "singleConnection": "-",
        "displayMasterpiece": "-",
        "beautiful": "-",
        "vertical": "-",
        "portable": "-",
        "resolution": "4K",
        "colorVolume": "Crystal",
        "contrast": "Normal",
        "brightness": "Normal",
        "processor": "Quantum 4K",
        "frequency": "60Hz",
        "freesync": "-",
        "ultrawide": "-",
        "gamingHub": "Sim",
        "hdmi": "0",
        "dolbyAtmos": "-",
        "movingSound": "Virtual",
        "soundPower": "20W",
        "smartThings": "Sim",
        "alexa": "Sim",
        "bixby": "Sim",
        "handsfree": "-",
        "googleduo": "-",
        "smartcam": "-"
    }
  },
  "UN60BU8000GXZD": {
    "sku": "UN60BU8000GXZD",
    "size": "60",
    "displayName": "BU8000",
    "cardColor": "#4276C4",
    "family": "Crystal UHD",
    "description": "Samsung Smart TV 60\" Crystal UHD 4K BU8000 2022, Painel Dynamic Crystal Color, Design slim, Tela sem limites, Visual Livre de Cabos, Alexa built in, Controle Remoto Único",
    "pdpUrl": "https://www.samsung.com/br/tvs/uhd-4k-tv/bu8000-60-inch-crystal-uhd-4k-smart-tv-un60bu8000gxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN60BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849893SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN60BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849893SRC-NA&keeplink=true",
    "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2758",
    "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2758&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN60BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286249SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN60BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286249SRC-NA&keeplink=true",
    "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2758&qty=1&seller=samsung&sc=1&sku=2452&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2758&2452-SSG-LANDINGPAGE-NA-NALP1718600SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2758&2452-SSG-LANDINGPAGE-NA-NALP1718439SRC-NA&keeplink=true",
    "price": "4099",
    "priceFormatted": "R$4.099,00",
    "passions": [
      "sports",
      "gaming",
      "movies",
      "smart"
    ],
    "image": {
      "src": BU8000,
      "thumbnail": BU8000,
      "alt": "BU8000 de 60 polegadas"
    },
    "features": [
        "smootherMotion",
        "cloud",
        "smarthome"
    ],
    "specs": {
        "thickness": "Até 2.7cm",
        "border": "Infinita",
        "singleConnection": "-",
        "displayMasterpiece": "-",
        "beautiful": "-",
        "vertical": "-",
        "portable": "-",
        "resolution": "4K",
        "colorVolume": "Crystal",
        "contrast": "Normal",
        "brightness": "Normal",
        "processor": "Quantum 4K",
        "frequency": "60Hz",
        "freesync": "-",
        "ultrawide": "-",
        "gamingHub": "Sim",
        "hdmi": "0",
        "dolbyAtmos": "-",
        "movingSound": "Virtual",
        "soundPower": "20W",
        "smartThings": "Sim",
        "alexa": "Sim",
        "bixby": "Sim",
        "handsfree": "-",
        "googleduo": "-",
        "smartcam": "-"
    }
  },
  "UN65BU8000GXZD": {
    "sku": "UN65BU8000GXZD",
    "size": "65",
    "displayName": "BU8000",
    "cardColor": "#4276C4",
    "family": "Crystal UHD",
    "description": "Samsung Smart TV 65\" Crystal UHD 4K BU8000 2022, Painel Dynamic Crystal Color, Design slim, Tela sem limites, Visual Livre de Cabos, Alexa built in, Controle Remoto Único",
    "pdpUrl": "https://www.samsung.com/br/tvs/uhd-4k-tv/bu8000-65-inch-crystal-uhd-4k-smart-tv-un65bu8000gxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN65BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849894SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN65BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849894SRC-NA&keeplink=true",
    "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2759",
    "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2759&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN65BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286250SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN65BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286250SRC-NA&keeplink=true",
    "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2759&qty=1&seller=samsung&sc=1&sku=2452&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2759&2452-SSG-LANDINGPAGE-NA-NALP1718601SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2759&2452-SSG-LANDINGPAGE-NA-NALP1718440SRC-NA&keeplink=true",
    "price": "4299",
    "priceFormatted": "R$4.299,00",
    "passions": [
      "sports",
      "gaming",
      "movies",
      "smart"
    ],
    "image": {
      "src": BU8000,
      "thumbnail": BU8000,
      "alt": "BU8000 de 65 polegadas"
    },
    "features": [
        "smootherMotion",
        "cloud",
        "smarthome"
    ],
    "specs": {
        "thickness": "Até 2.7cm",
        "border": "Infinita",
        "singleConnection": "-",
        "displayMasterpiece": "-",
        "beautiful": "-",
        "vertical": "-",
        "portable": "-",
        "resolution": "4K",
        "colorVolume": "Crystal",
        "contrast": "Normal",
        "brightness": "Normal",
        "processor": "Quantum 4K",
        "frequency": "60Hz",
        "freesync": "-",
        "ultrawide": "-",
        "gamingHub": "Sim",
        "hdmi": "0",
        "dolbyAtmos": "-",
        "movingSound": "Virtual",
        "soundPower": "20W",
        "smartThings": "Sim",
        "alexa": "Sim",
        "bixby": "Sim",
        "handsfree": "-",
        "googleduo": "-",
        "smartcam": "-"
    }
  },
  "UN70BU8000GXZD": {
    "sku": "UN70BU8000GXZD",
    "size": "70",
    "displayName": "BU8000",
    "cardColor": "#4276C4",
    "family": "Crystal UHD",
    "description": "Samsung Smart TV 70\" Crystal UHD 4K BU8000 2022, Painel Dynamic Crystal Color, Design slim, Tela sem limites, Visual Livre de Cabos, Alexa built in, Controle Remoto Único",
    "pdpUrl": "https://www.samsung.com/br/tvs/uhd-4k-tv/bu8000-70-inch-crystal-uhd-4k-smart-tv-un70bu8000gxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN70BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849899SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN70BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849899SRC-NA&keeplink=true",
    "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=3207",
    "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=3207&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50Q80BAGXZD-SSG-LANDINGPAGE-NA-NALP871742SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50Q80BAGXZD-SSG-LANDINGPAGE-NA-NALP871742SRC-NA&keeplink=true",
    "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=3207&qty=1&seller=samsung&sc=1&sku=2452&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-3207&2452-SSG-LANDINGPAGE-NA-NALP1718602SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-3207&2452-SSG-LANDINGPAGE-NA-NALP1718441SRC-NA&keeplink=true",
    "price": "4799",
    "priceFormatted": "R$4.799,00",
    "passions": [
      "sports",
      "gaming",
      "movies",
      "smart"
    ],
    "image": {
      "src": BU8000,
      "thumbnail": BU8000,
      "alt": "BU8000 de 70 polegadas"
    },
    "features": [
        "smootherMotion",
        "cloud",
        "smarthome"
    ],
    "specs": {
        "thickness": "Até 2.7cm",
        "border": "Infinita",
        "singleConnection": "-",
        "displayMasterpiece": "-",
        "beautiful": "-",
        "vertical": "-",
        "portable": "-",
        "resolution": "4K",
        "colorVolume": "Crystal",
        "contrast": "Normal",
        "brightness": "Normal",
        "processor": "Quantum 4K",
        "frequency": "60Hz",
        "freesync": "-",
        "ultrawide": "-",
        "gamingHub": "Sim",
        "hdmi": "0",
        "dolbyAtmos": "-",
        "movingSound": "Virtual",
        "soundPower": "20W",
        "smartThings": "Sim",
        "alexa": "Sim",
        "bixby": "Sim",
        "handsfree": "-",
        "googleduo": "-",
        "smartcam": "-"
    }
  },
  "UN75BU8000GXZD": {
    "sku": "UN75BU8000GXZD",
    "size": "75",
    "displayName": "BU8000",
    "cardColor": "#4276C4",
    "family": "Crystal UHD",
    "description": "Samsung Smart TV 75\" Crystal UHD 4K BU8000 2022, Painel Dynamic Crystal Color, Design slim, Tela sem limites, Visual Livre de Cabos, Alexa built in, Controle Remoto Único",
    "pdpUrl": "https://www.samsung.com/br/tvs/uhd-4k-tv/bu8000-75-inch-crystal-uhd-4k-smart-tv-un75bu8000gxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN75BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849895SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN75BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849895SRC-NA&keeplink=true",
    "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2760",
    "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2760&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN75BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286251SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN75BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286251SRC-NA&keeplink=true",
    "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2760&qty=1&seller=samsung&sc=1&sku=2452&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2760&2452-SSG-LANDINGPAGE-NA-NALP1718603SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2760&2452-SSG-LANDINGPAGE-NA-NALP1718442SRC-NA&keeplink=true",
    "price": "6849",
    "priceFormatted": "R$6.849,00",
    "passions": [
      "sports",
      "gaming",
      "movies",
      "smart"
    ],
    "image": {
      "src": BU8000,
      "thumbnail": BU8000,
      "alt": "BU8000 de 75 polegadas"
    },
    "features": [
        "smootherMotion",
        "cloud",
        "smarthome"
    ],
    "specs": {
        "thickness": "Até 2.7cm",
        "border": "Infinita",
        "singleConnection": "-",
        "displayMasterpiece": "-",
        "beautiful": "-",
        "vertical": "-",
        "portable": "-",
        "resolution": "4K",
        "colorVolume": "Crystal",
        "contrast": "Normal",
        "brightness": "Normal",
        "processor": "Quantum 4K",
        "frequency": "60Hz",
        "freesync": "-",
        "ultrawide": "-",
        "gamingHub": "Sim",
        "hdmi": "0",
        "dolbyAtmos": "-",
        "movingSound": "Virtual",
        "soundPower": "20W",
        "smartThings": "Sim",
        "alexa": "Sim",
        "bixby": "Sim",
        "handsfree": "-",
        "googleduo": "-",
        "smartcam": "-"
    }
  },
  "UN85BU8000GXZD": {
    "sku": "UN85BU8000GXZD",
    "size": "85",
    "displayName": "BU8000",
    "cardColor": "#4276C4",
    "family": "Crystal UHD",
    "description": "Samsung Smart TV 85\" Crystal UHD 4K BU8000 2022, Painel Dynamic Crystal Color, Design slim, Tela sem limites, Visual Livre de Cabos, Alexa built in, Controle Remoto Único",
    "pdpUrl": "https://www.samsung.com/br/tvs/uhd-4k-tv/bu8000-85-inch-crystal-uhd-4k-smart-tv-un85bu8000gxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN85BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849896SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN85BU8000GXZDPDP-SSG-LANDINGPAGE-NA-NALP849896SRC-NA&keeplink=true",
    "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2761",
    "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-crystal-uhd-4k-bu8000-2022-1964/p?skuId=2761&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN85BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286252SRC-NA&utm_source=&utm_medium=&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-UN85BU8000GXZD -SSG-LANDINGPAGE-NA-NALP286252SRC-NA&keeplink=true",
    "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2761&qty=1&seller=samsung&sc=1&sku=2452&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2761&2452-SSG-LANDINGPAGE-NA-NALP1718604SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2761&2452-SSG-LANDINGPAGE-NA-NALP1718443SRC-NA&keeplink=true",
    "price": "10499",
    "priceFormatted": "R$10.499,00",
    "passions": [
      "sports",
      "gaming",
      "movies",
      "smart"
    ],
    "image": {
      "src": BU8000,
      "thumbnail": BU8000,
      "alt": "BU8000 de 85 polegadas"
    },
    "features": [
        "smootherMotion",
        "cloud",
        "smarthome"
    ],
    "specs": {
        "thickness": "Até 2.7cm",
        "border": "Infinita",
        "singleConnection": "-",
        "displayMasterpiece": "-",
        "beautiful": "-",
        "vertical": "-",
        "portable": "-",
        "resolution": "4K",
        "colorVolume": "Crystal",
        "contrast": "Normal",
        "brightness": "Normal",
        "processor": "Quantum 4K",
        "frequency": "60Hz",
        "freesync": "-",
        "ultrawide": "-",
        "gamingHub": "Sim",
        "hdmi": "0",
        "dolbyAtmos": "-",
        "movingSound": "Virtual",
        "soundPower": "20W",
        "smartThings": "Sim",
        "alexa": "Sim",
        "bixby": "Sim",
        "handsfree": "-",
        "googleduo": "-",
        "smartcam": "-"
    }
  },
  "QN43LS03BAGXZD": {
      "sku": "QN43LS03BAGXZD",
      "size": "43",
      "displayName": "The Frame",
      "cardColor": "#000",
      "family": "Lifestyle",
      "description": "Samsung Smart TV 43\" QLED 4K The Frame 2022 LS03B, Tela Matte, Design slim, Suporte de parede slim incluso, Única Conexão, Molduras customizáveis, Modo Arte",
      "pdpUrl": "https://www.samsung.com/br/lifestyle-tvs/the-frame/ls03b-43-inch-the-frame-qled-4k-smart-tv-black-qn43ls03bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN43LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849883SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN43LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849883SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2893",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2893&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN43LS03BAGXZD -SSG-LANDINGPAGE-NA-NALP286239SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN43LS03BAGXZD -SSG-LANDINGPAGE-NA-NALP286239SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2893&qty=1&seller=samsung&sc=1&sku=3088&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-NA-SSG-LANDINGPAGE-NA-NALP1721192SRC-NA&utm_source=MARKETING&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-NA-SSG-LANDINGPAGE-NA-NALP1721192SRC-NA&keeplink=true",
      "price": "3549",
      "priceFormatted": "R$3.549,00",
      "passions": [
        "design",
        "smart"
      ],
      "image": {
        "src": TheFrame,
        "thumbnail": TheFrame,
        "alt": "The Frame de 43 polegadas"
      },
      "features": [
          "masterpiece",
          "videocall",
          "smarthome"
      ],
      "specs": {
          "thickness": "2,5 cm",
          "border": "Emoldurada|Molduras customizáveis, que deixam a TV com a cara do seu ambiente (acessório vendido separadamente)",
          "singleConnection": "Sim|Suporte de parede Slim incluso",
          "displayMasterpiece": "Sim",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K<sup>4</sup>",
          "colorVolume": "QLED",
          "contrast": "Dual LED<sup>5</sup>",
          "brightness": "Matte|Tela com acabamento Matte",
          "processor": "Quantum 4K<sup>5</sup>",
          "frequency": "Até 120Hz<sup>6</sup>",
          "freesync": "Freesync<sup>7</sup>",
          "ultrawide": "Sim<sup>5</sup>",
          "gamingHub": "Sim",
          "hdmi": "Sim<sup>7</sup>",
          "dolbyAtmos": "-",
          "movingSound": "Sim<sup>8</sup>",
          "soundPower": "Até 40W RMS<sup>9</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "-",
          "googleduo": "Sim<sup>5</sup>",
          "smartcam": "-"
      }
  },
  "QN50LS03BAGXZD": {
      "sku": "QN50LS03BAGXZD",
      "size": "50",
      "displayName": "The Frame",
      "cardColor": "#000",
      "family": "Lifestyle",
      "description": "Samsung Smart TV 50\" QLED 4K The Frame 2022 LS03B, Tela Matte, Design slim, Suporte de parede slim incluso, Única Conexão, Molduras customizáveis, Modo Arte",
      "pdpUrl": "https://www.samsung.com/br/lifestyle-tvs/the-frame/ls03b-50-inch-the-frame-qled-4k-smart-tv-black-qn50ls03bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849884SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849884SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2894",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2894&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50LS03BAGXZD -SSG-LANDINGPAGE-NA-NALP286240SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN50LS03BAGXZD -SSG-LANDINGPAGE-NA-NALP286240SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2894&qty=1&seller=samsung&sc=1&sku=3088&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2894&3088-SSG-LANDINGPAGE-NA-NALP1718607SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2894&3088-SSG-LANDINGPAGE-NA-NALP1718446SRC-NA&keeplink=true",
      "price": "4099",
      "priceFormatted": "R$4.099,00",
      "passions": [
        "design",
        "smart"
      ],
      "image": {
        "src": TheFrame,
        "thumbnail": TheFrame,
        "alt": "The Frame de 50 polegadas"
      },
      "features": [
          "masterpiece",
          "videocall",
          "smarthome"
      ],
      "specs": {
          "thickness": "2,5 cm",
          "border": "Emoldurada|Molduras customizáveis, que deixam a TV com a cara do seu ambiente (acessório vendido separadamente)",
          "singleConnection": "Sim|Suporte de parede Slim incluso",
          "displayMasterpiece": "Sim",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K<sup>4</sup>",
          "colorVolume": "QLED",
          "contrast": "Dual LED<sup>5</sup>",
          "brightness": "Matte|Tela com acabamento Matte",
          "processor": "Quantum 4K<sup>5</sup>",
          "frequency": "Até 120Hz<sup>6</sup>",
          "freesync": "Freesync<sup>7</sup>",
          "ultrawide": "Sim<sup>5</sup>",
          "gamingHub": "Sim",
          "hdmi": "Sim<sup>7</sup>",
          "dolbyAtmos": "-",
          "movingSound": "Sim<sup>8</sup>",
          "soundPower": "Até 40W RMS<sup>9</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "-",
          "googleduo": "Sim<sup>5</sup>",
          "smartcam": "-"
      }
  },
  "QN55LS03BAGXZD": {
      "sku": "QN55LS03BAGXZD",
      "size": "55",
      "displayName": "The Frame",
      "cardColor": "#000",
      "family": "Lifestyle",
      "description": "Samsung Smart TV 55\" QLED 4K The Frame 2022 LS03B, Tela Matte, Design slim, Suporte de parede slim incluso, Única Conexão, Molduras customizáveis, Modo Arte",
      "pdpUrl": "https://www.samsung.com/br/lifestyle-tvs/the-frame/ls03b-55-inch-the-frame-qled-4k-smart-tv-black-qn55ls03bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849885SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849885SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2905",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2905&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55LS03BAGXZD-SSG-LANDINGPAGE-NA-NALP286241SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55LS03BAGXZD-SSG-LANDINGPAGE-NA-NALP286241SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2905&qty=1&seller=samsung&sc=1&sku=3088&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2905&3088-SSG-LANDINGPAGE-NA-NALP1718608SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2905&3088-SSG-LANDINGPAGE-NA-NALP1718447SRC-NA&keeplink=true",
      "price": "4499",
      "priceFormatted": "R$4.499,00",
      "passions": [
        "design",
        "smart"
      ],
      "image": {
        "src": TheFrame,
        "thumbnail": TheFrame,
        "alt": "The Frame de 55 polegadas"
      },
      "features": [
          "masterpiece",
          "videocall",
          "smarthome"
      ],
      "specs": {
          "thickness": "2,5 cm",
          "border": "Emoldurada|Molduras customizáveis, que deixam a TV com a cara do seu ambiente (acessório vendido separadamente)",
          "singleConnection": "Sim|Suporte de parede Slim incluso",
          "displayMasterpiece": "Sim",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K<sup>4</sup>",
          "colorVolume": "QLED",
          "contrast": "Dual LED<sup>5</sup>",
          "brightness": "Matte|Tela com acabamento Matte",
          "processor": "Quantum 4K<sup>5</sup>",
          "frequency": "Até 120Hz<sup>6</sup>",
          "freesync": "Freesync<sup>7</sup>",
          "ultrawide": "Sim<sup>5</sup>",
          "gamingHub": "Sim",
          "hdmi": "Sim<sup>7</sup>",
          "dolbyAtmos": "-",
          "movingSound": "Sim<sup>8</sup>",
          "soundPower": "Até 40W RMS<sup>9</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "-",
          "googleduo": "Sim<sup>5</sup>",
          "smartcam": "-"
      }
  },
  "QN65LS03BAGXZD": {
      "sku": "QN65LS03BAGXZD",
      "size": "65",
      "displayName": "The Frame",
      "cardColor": "#000",
      "family": "Lifestyle",
      "description": "Samsung Smart TV 65\" QLED 4K The Frame 2022 LS03B, Tela Matte, Design slim, Suporte de parede slim incluso, Única Conexão, Molduras customizáveis, Modo Arte",
      "pdpUrl": "https://www.samsung.com/br/lifestyle-tvs/the-frame/ls03b-65-inch-the-frame-qled-4k-smart-tv-black-qn65ls03bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849886SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849886SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2895",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2895&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65LS03BAGXZD -SSG-LANDINGPAGE-NA-NALP286242SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN65LS03BAGXZD -SSG-LANDINGPAGE-NA-NALP286242SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2895&qty=1&seller=samsung&sc=1&sku=3088&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2895&3088-SSG-LANDINGPAGE-NA-NALP1718609SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2895&3088-SSG-LANDINGPAGE-NA-NALP1718448SRC-NA&keeplink=true",
      "price": "7799",
      "priceFormatted": "R$7.799,00",
      "passions": [
        "design",
        "smart"
      ],
      "image": {
        "src": TheFrame,
        "thumbnail": TheFrame,
        "alt": "The Frame de 65 polegadas"
      },
      "features": [
          "masterpiece",
          "videocall",
          "smarthome"
      ],
      "specs": {
          "thickness": "2,5 cm",
          "border": "Emoldurada|Molduras customizáveis, que deixam a TV com a cara do seu ambiente (acessório vendido separadamente)",
          "singleConnection": "Sim|Suporte de parede Slim incluso",
          "displayMasterpiece": "Sim",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K<sup>4</sup>",
          "colorVolume": "QLED",
          "contrast": "Dual LED<sup>5</sup>",
          "brightness": "Matte|Tela com acabamento Matte",
          "processor": "Quantum 4K<sup>5</sup>",
          "frequency": "Até 120Hz<sup>6</sup>",
          "freesync": "Freesync<sup>7</sup>",
          "ultrawide": "Sim<sup>5</sup>",
          "gamingHub": "Sim",
          "hdmi": "Sim<sup>7</sup>",
          "dolbyAtmos": "-",
          "movingSound": "Sim<sup>8</sup>",
          "soundPower": "Até 40W RMS<sup>9</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "-",
          "googleduo": "Sim<sup>5</sup>",
          "smartcam": "-"
      }
  },
  "QN75LS03BAGXZD": {
      "sku": "QN75LS03BAGXZD",
      "size": "75",
      "displayName": "The Frame",
      "cardColor": "#000",
      "family": "Lifestyle",
      "description": "Samsung Smart TV 75\" QLED 4K The Frame 2022 LS03B, Tela Matte, Design slim, Suporte de parede slim incluso, Única Conexão, Molduras customizáveis, Modo Arte",
      "pdpUrl": "https://www.samsung.com/br/lifestyle-tvs/the-frame/ls03b-75-inch-the-frame-qled-4k-smart-tv-black-qn75ls03bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849887SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849887SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2896",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2896&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75LS03BAGXZD -SSG-LANDINGPAGE-NA-NALP286243SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN75LS03BAGXZD -SSG-LANDINGPAGE-NA-NALP286243SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2896&qty=1&seller=samsung&sc=1&sku=3088&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2896&3088-SSG-LANDINGPAGE-NA-NALP1718610SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2896&3088-SSG-LANDINGPAGE-NA-NALP1718449SRC-NA&keeplink=true",
      "price": "12399",
      "priceFormatted": "R$12.399,00",
      "passions": [
        "design",
        "smart"
      ],
      "image": {
        "src": TheFrame,
        "thumbnail": TheFrame,
        "alt": "The Frame de 75 polegadas"
      },
      "features": [
          "masterpiece",
          "videocall",
          "smarthome"
      ],
      "specs": {
          "thickness": "2,5 cm",
          "border": "Emoldurada|Molduras customizáveis, que deixam a TV com a cara do seu ambiente (acessório vendido separadamente)",
          "singleConnection": "Sim|Suporte de parede Slim incluso",
          "displayMasterpiece": "Sim",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K<sup>4</sup>",
          "colorVolume": "QLED",
          "contrast": "Dual LED<sup>5</sup>",
          "brightness": "Matte|Tela com acabamento Matte",
          "processor": "Quantum 4K<sup>5</sup>",
          "frequency": "Até 120Hz<sup>6</sup>",
          "freesync": "Freesync<sup>7</sup>",
          "ultrawide": "Sim<sup>5</sup>",
          "gamingHub": "Sim",
          "hdmi": "Sim<sup>7</sup>",
          "dolbyAtmos": "-",
          "movingSound": "Sim<sup>8</sup>",
          "soundPower": "Até 40W RMS<sup>9</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "-",
          "googleduo": "Sim<sup>5</sup>",
          "smartcam": "-"
      }
  },
  "QN85LS03BAGXZD": {
      "sku": "QN85LS03BAGXZD",
      "size": "85",
      "displayName": "The Frame",
      "cardColor": "#000",
      "family": "Lifestyle",
      "description": "Samsung Smart TV 85\" QLED 4K The Frame 2022 LS03B, Tela Matte, Design slim, Suporte de parede slim incluso, Única Conexão, Molduras customizáveis, Modo Arte",
      "pdpUrl": "https://www.samsung.com/br/lifestyle-tvs/the-frame/ls03b-85-inch-the-frame-qled-4k-smart-tv-black-qn85ls03bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849888SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85LS03BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849888SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2897",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-frame-2022-ls03b-2036/p?skuId=2897&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85LS03BAGXZD-SSG-LANDINGPAGE-NA-NALP286244SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN85LS03BAGXZD-SSG-LANDINGPAGE-NA-NALP286244SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2897&qty=1&seller=samsung&sc=1&sku=3088&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2897&3088-SSG-LANDINGPAGE-NA-NALP1718611SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2897&3088-SSG-LANDINGPAGE-NA-NALP1718450SRC-NA&keeplink=true",
      "price": "21899",
      "priceFormatted": "R$21.899,00",
      "passions": [
        "design",
        "smart"
      ],
      "image": {
        "src": TheFrame,
        "thumbnail": TheFrame,
        "alt": "The Frame de 85 polegadas"
      },
      "features": [
          "masterpiece",
          "videocall",
          "smarthome"
      ],
      "specs": {
          "thickness": "2,5 cm",
          "border": "Emoldurada|Molduras customizáveis, que deixam a TV com a cara do seu ambiente (acessório vendido separadamente)",
          "singleConnection": "Sim|Suporte de parede Slim incluso",
          "displayMasterpiece": "Sim",
          "beautiful": "-",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K<sup>4</sup>",
          "colorVolume": "QLED",
          "contrast": "Dual LED<sup>5</sup>",
          "brightness": "Matte|Tela com acabamento Matte",
          "processor": "Quantum 4K<sup>5</sup>",
          "frequency": "Até 120Hz<sup>6</sup>",
          "freesync": "Freesync<sup>7</sup>",
          "ultrawide": "Sim<sup>5</sup>",
          "gamingHub": "Sim",
          "hdmi": "Sim<sup>7</sup>",
          "dolbyAtmos": "-",
          "movingSound": "Sim<sup>8</sup>",
          "soundPower": "Até 40W RMS<sup>9</sup>",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "-",
          "googleduo": "Sim<sup>5</sup>",
          "smartcam": "-"
      }
  },
  "QN55LS01BAGXZD": {
      "sku": "QN55LS01BAGXZD",
      "size": "55",
      "displayName": "The Serif",
      "cardColor": "#000",
      "family": "Lifestyle",
      "description": "Samsung Smart TV 55\" QLED 4K The Serif 2022 55LS01B branca, Design 360, Suporte de chão, NFC, Airplay 2, Multitela",
      "pdpUrl": "https://www.samsung.com/br/lifestyle-tvs/the-serif/ls01b-55-inch-the-serif-qled-4k-smart-tv-cloud-white-qn55ls01bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55LS01BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849889SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55LS01BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849889SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-55-polegadas-qled-4k-the-serif-2022-55ls01b-branca-tela-matte-design-360-suporte-de-chao-nfc-airplay-2-multitela-2082/p?skuId=2967",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-55-polegadas-qled-4k-the-serif-2022-55ls01b-branca-tela-matte-design-360-suporte-de-chao-nfc-airplay-2-multitela-2082/p?skuId=2967&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55LS01BAGXZD-SSG-LANDINGPAGE-NA-NALP286245SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN55LS01BAGXZD-SSG-LANDINGPAGE-NA-NALP286245SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2967&qty=1&seller=samsung&sc=1&sku=3088&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2967&3088-SSG-LANDINGPAGE-NA-NALP1718612SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2967&3088-SSG-LANDINGPAGE-NA-NALP1718451SRC-NA&keeplink=true",
      "price": "6999",
      "priceFormatted": "R$6.999,00",
      "passions": [
        "design",
      ],
      "image": {
        "src": TheSerif,
        "thumbnail": TheSerif,
        "alt": "The Serif de 43 polegadas"
      },
      "features": [
          "iconic"
      ],
      "specs": {
          "thickness": "Co-criada por designers",
          "border": "-",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "Sim",
          "vertical": "-",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QLED",
          "contrast": "Mega contraste",
          "brightness": "Matte|Tela com acabamento Matte",
          "processor": "Quantum 4K ",
          "frequency": "120 Hz",
          "freesync": "Freesync",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "Sim",
          "dolbyAtmos": "-",
          "movingSound": "Virtual",
          "soundPower": "40W RMS",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "-",
          "googleduo": "Sim",
          "smartcam": "-"
      }
  },
  "QN43LS05BAGXZD": {
      "sku": "QN43LS05BAGXZD",
      "size": "43",
      "displayName": "The Sero",
      "cardColor": "#000",
      "family": "Lifestyle",
      "description": "Samsung Smart TV 43|\" QLED 4K The Sero 2022, TV Vertical, Som de 60W RMS e 4.1 canais, Modo Retrato, Modo Ambiente 3.0",
      "pdpUrl": "https://www.samsung.com/br/lifestyle-tvs/the-sero/ls05b-43-inch-the-sero-qled-4k-smart-tv-navy-blue-qn43ls05bagxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN43LS05BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849898SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-QN43LS05BAGXZDPDP-SSG-LANDINGPAGE-NA-NALP849898SRC-NA&keeplink=true",
      "shopUrl": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-sero-2022-43--tela-matte-tv-vertical-som-de-60w-rms-e-4-1-canais-modo-retrato-modo-ambiente-2081/p?skuId=2966",
      "shopUrlTagged": "https://shop.samsung.com/br/samsung-smart-tv-qled-4k-the-sero-2022-43--tela-matte-tv-vertical-som-de-60w-rms-e-4-1-canais-modo-retrato-modo-ambiente-2081/p?skuId=2966&cid=br_OWNED_SHOP_MARKETING_THESERO_NOPHASE_TV_OTHER_THESERO-NA-NA-TEXT-3102022_SAMSUNG-STORE-SHOP:SAMSUNG-NA-NA-NA-NA-BR-A-DKMO-ANDIOS-NA-NA-SSG-LANDINGPAGE-NA-NALP1203616SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_THESERO_NOPHASE_TV_OTHER_THESERO-NA-NA-TEXT-3102022_SAMSUNG-STORE-SHOP:SAMSUNG-NA-NA-NA-NA-BR-A-DKMO-ANDIOS-NA-NA-SSG-LANDINGPAGE-NA-NALP1203616SRC-NA&keeplink=true",
      "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2966&qty=1&seller=samsung&sc=1&sku=3088&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2966&3088-SSG-LANDINGPAGE-NA-NALP1718613SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2966&3088-SSG-LANDINGPAGE-NA-NALP1718452SRC-NA&keeplink=true",
      "price": "7499",
      "priceFormatted": "R$7.499,00",
      "passions": [
        "design",
      ],
      "image": {
        "src": TheSero,
        "thumbnail": TheSero,
        "alt": "The Sero de 43 polegadas"
      },
      "features": [
          "vertical"
      ],
      "specs": {
          "thickness": "Base Azul Navy acoplada",
          "border": "-",
          "singleConnection": "-",
          "displayMasterpiece": "-",
          "beautiful": "-",
          "vertical": "Sim",
          "portable": "-",
          "resolution": "4K",
          "colorVolume": "QLED",
          "contrast": "Mega contraste",
          "brightness": "Matte|Tela com acabamento Matte",
          "processor": "Quantum 4K ",
          "frequency": "60Hz",
          "freesync": "-",
          "ultrawide": "Sim",
          "gamingHub": "Sim",
          "hdmi": "-",
          "dolbyAtmos": "-",
          "movingSound": "Virtual",
          "soundPower": "60W RMS",
          "smartThings": "Sim",
          "alexa": "Sim",
          "bixby": "Sim",
          "handsfree": "-",
          "googleduo": "Sim",
          "smartcam": "-"
      }
  },
  "SP-LSP3BLAXZD": {
    "sku": "SP-LSP3BLAXZD",
    "size": "30",
    "inchTv": true,
    "displayName": "The Freestyle",
    "cardColor": "#000",
    "family": "Lifestyle",
    "description": "Samsung The Freestyle Projetor Smart Portátil, de 30 a 100\", configuração instantânea, plataforma Tizen, som 360º, conectividade com celular e Bluetooth",
    "pdpUrl": "https://www.samsung.com/br/projectors/the-freestyle/lsp3b-the-freestyle-sp-lsp3blaxzd/?cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-SPLSP3BLAXZDPDP-SSG-LANDINGPAGE-NA-NALP849882SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-23092022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-SPLSP3BLAXZDPDP-SSG-LANDINGPAGE-NA-NALP849882SRC-NA&keeplink=true",
    "shopUrl": "https://shop.samsung.com/br/samsung-the-freestyle-projetor-smart-portatil-de-30-a-100-polegadas-1934/p?skuId=2717",
    "shopUrlTagged": "https://shop.samsung.com/br/samsung-the-freestyle-projetor-smart-portatil-de-30-a-100-polegadas-1934/p?skuId=2717&cid=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-SPLSP3BLAXZD-SSG-LANDINGPAGE-NA-NALP286238SRC-NA&utm_source=MARKETING&utm_medium=SHOP&utm_campaign=br_OWNED_SHOP_MARKETING_TV_NOPHASE_TV_OTHER_COPADOMUNDO-NA-NA-TEXT-26082022_SAMSUNG-CONV-COPADOMUNDO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-SPLSP3BLAXZD-SSG-LANDINGPAGE-NA-NALP286238SRC-NA&keeplink=true",
    "shopSoundbarUrlTagged": "https://shop.samsung.com/br/checkout/cart/add?sc=1&sku=2717&qty=1&seller=samsung&sc=1&sku=3088&qty=1&seller=samsung&cid=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2717&3088-SSG-LANDINGPAGE-NA-NALP1718614SRC-NA&utm_source=SHOP&utm_medium=OTHER&utm_campaign=br_OWNED_SHOP_MARKETING_SOUNDBAR_NOPHASE_TV_OTHER_SOUNDBAR:GEN-NA-NA-TEXT-8112022_SAMSUNG-CONV-SOUNDBAR:GENERICO-NA-SAMSUNG-NA-NA-BR-A-NA-NA-NA-2717&3088-SSG-LANDINGPAGE-NA-NALP1718453SRC-NA&keeplink=true",
    "price": "4799",
    "priceFormatted": "R$4.799,00",
    "passions": [
      "design",
    ],
    "image": {
      "src": TheFreestyle,
      "thumbnail": TheFreestyle,
      "alt": "The Freestyle projetor"
    },
    "features": [
        "projector"
    ],
    "specs": {
        "thickness": "-",
        "border": "-",
        "singleConnection": "-",
        "displayMasterpiece": "-",
        "beautiful": "-",
        "vertical": "-",
        "portable": "Sim",
        "resolution": "FHD",
        "colorVolume": "DLP",
        "contrast": "230 Ansi-Lumem",
        "brightness": "-",
        "processor": "Crystal",
        "frequency": "N/A",
        "freesync": "-",
        "ultrawide": "-",
        "gamingHub": "Sim",
        "hdmi": "-",
        "dolbyAtmos": "-",
        "movingSound": "-",
        "soundPower": "Premium 360°",
        "smartThings": "Sim",
        "alexa": "Sim",
        "bixby": "Sim",
        "handsfree": "Sim<sup>10</sup>",
        "googleduo": "-",
        "smartcam": "-"
    }
  }
}

export default products;